import { BASE_URL } from '../api/inquiries';

// Generate or Retrieve Visitor ID
const getVisitorId = () => {
    let vid = localStorage.getItem('visitor_id');
    if (!vid) {
        vid = crypto.randomUUID ? crypto.randomUUID() : 'v-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('visitor_id', vid);
    }
    return vid;
};

export const logEvent = async (type, target = null, result = 'None', additionalPath = null) => {
    try {
        const currentPath = additionalPath || window.location.pathname;

        // System Admin exclusion
        if (currentPath.startsWith('/admin')) {
            return;
        }

        const payload = {
            type, // VIEW, CLICK, API, POPUP
            path: currentPath,
            target,
            result,
            visitorId: getVisitorId(),
            referrer: document.referrer,
            xClientPath: currentPath // Redundant but consistent
        };

        // Use sendBeacon for reliability on page unload, or fallback to fetch
        const url = `${BASE_URL}/api/crm/log`;

        if (navigator.sendBeacon) {
            const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
            navigator.sendBeacon(url, blob);
        } else {
            await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
        }
    } catch (e) {
        // Silent fail for logs
        console.warn('Logging failed', e);
    }
};

// Auto-track clicks on interactive elements
export const initGlobalClickListener = () => {
    document.addEventListener('click', (e) => {
        const target = e.target.closest('a, button, [data-track]');
        if (target) {
            const label = target.getAttribute('data-track') || target.id || target.innerText || target.href;
            if (label) {
                logEvent('CLICK', label.substring(0, 50)); // Limit length
            }
        }
    }, true);
};
